// extracted by mini-css-extract-plugin
module.exports = {"borderBottomTransparent":"styles-module__borderBottomTransparent___25NJP","borderBottomDarkPrimary":"styles-module__borderBottomDarkPrimary___1-wWo"};